import {DateOnlyIsoString, DateTimeIsoString, SelectOptions, StatusChipColors} from '@aviary/store/common/common.types';
import {CatalogRecord} from '@store/catalog/catalog.types';

export const ITEM_REQUESTS_FEATURE_KEY = 'item-requests';

export interface ItemRequest {
  readonly id: number;
  readonly organizationId: number;
  readonly requestedBranchId: number;
  readonly patronId: number;
  readonly status: ItemRequestStatus;
  readonly title: string;
  readonly author: string;
  readonly isbn: string;
  readonly materialTypeDesc: string;
  readonly notes: string;
  readonly hasUnreadStaffComments: boolean;
  readonly printType: string;
  readonly yearOfPublication: string;
  readonly active: boolean;
  readonly created: DateTimeIsoString;
  readonly modified: DateTimeIsoString;

  readonly comments: ItemRequestComment[];
  readonly pickupBranchName: string;
  readonly linkedCatalogRecord: CatalogRecord;
  readonly hasLinkedCatalogRecord: boolean;
  readonly holdPlaced: boolean;
  readonly decisionDate: DateTimeIsoString;
}

export type ItemRequestStatus = 'REQUESTED' | 'PENDING' | 'APPROVED' | 'DECLINED' | 'CANCELED';

export const DISPLAYABLE_ITEM_REQUEST_STATUS: Map<ItemRequestStatus, string> = new Map([
  ['REQUESTED', 'Requested'],
  ['PENDING', 'Pending'],
  ['APPROVED', 'Settled'],
  ['DECLINED', 'Settled'],
  ['CANCELED', 'Canceled'],
]);

export const ITEM_REQUEST_STATUS_CHIP_COLORS: StatusChipColors<ItemRequestStatus> = {
  'status-positive': ['APPROVED', 'DECLINED'],
  'status-neutral': ['REQUESTED'],
  'status-negative': [],
  'status-transitional': ['PENDING'],
  'status-inactive': ['CANCELED']
};

export const CANCELABLE_STATUSES: ItemRequestStatus[] = ['REQUESTED', 'PENDING'];

export interface ItemRequestComment {
  readonly id: number;
  readonly patronId: number;
  readonly userId: number;
  readonly patronItemRequestId: number;
  readonly comment: string;
  readonly active: boolean;
  readonly created: DateTimeIsoString;
  readonly modified: DateTimeIsoString;
}

export interface CreateItemRequestValue {
  itemTitle: string;
  itemAuthor: string;
  requestedBranchId: number;
  isbn: string;
  materialTypeDesc: string;
  yearOfPublication: string;
  printType: PrintType | '';
  notes: string;
  confirmCheckbox: boolean;
}

export type PrintType = 'Regular Print' | 'Large Print';

export const PRINT_TYPE_SELECT_OPTIONS: SelectOptions<PrintType> = [
  {displayName: 'Regular Print', value: 'Regular Print'},
  {displayName: 'Large Print', value: 'Large Print'}
];

export interface ItemRequestCommentByDate {
  readonly date: DateOnlyIsoString;
  readonly comments: ItemRequestComment[];
}

export interface ItemRequestDialogData {
  itemRequest: ItemRequest;
}
